import type { App } from "vue";
import { startOfflineRuntime } from "@/offline/runtime";

/**
 * Starts the offline runtime's schedule (background refresh on a timer, on
 * focus, and on reconnect).
 *
 * It only arms the triggers — the first download happens once permissions are
 * known, from `GetPermission`. Plugins load alphabetically, so this runs after
 * `2.pinia` (stores exist) and after `network-status` (the reachability signal
 * is already bound), which is exactly the order it needs.
 */
export default function (_app: App) {
  if (typeof window === "undefined")
    return;

  try {
    startOfflineRuntime();
  }
  catch (error) {
    // Offline mode is an enhancement: if it cannot start, the app must still run
    // exactly as it did before.
    console.warn("Offline runtime failed to start:", error);
  }
}
